import {convertToInt} from '@utils/helpers';
import {getSortingValue} from '@modules/events/utils/eventSchedule';

export const Columns = {
    'event_id': {
        label: 'ID',
        sorting: (row) => (row.event_id ? convertToInt(row.event_id) : 0),
        header: {
            align: 'center',
            isCollapsed: true,
        },
        content: {
            align: 'center',
        },
    },
    'match_or_stage_id': {
        label: 'Match ID / ',
        subLabel: 'Stage ID',
        sorting: (row) => {
            if (row.match_id) return convertToInt(row.match_id);

            if (row.stage_id) return convertToInt(row.stage_id);

            return 0;
        },
        header: {
            align: 'center',
            isCollapsed: true,
        },
        content: {
            align: 'center',
        },
    },
    'start_datetime': {
        label: 'Date/time',
        sorting: true,
        header: {
            align: 'center',
        },
        content: {
            align: 'center',
            singleLine: true,
        },
    },
    'sport_or_content_category_level_1': {
        label: 'Sport /',
        subLabel: '1st level category',
        sorting: (row) => (
            getSortingValue(row.sport_or_content_category_level_1)
        ),
    },
    'category_or_content_category_level_2': {
        label: 'Category /',
        subLabel: '1st stage category /',
        subSubLabel: '2nd level category',
        sorting: (row) => (
            getSortingValue(row.category_or_content_category_level_2)
        ),
    },
    'tournament_or_content_category_level_3': {
        label: 'Tournament /',
        subLabel: '2nd stage category /',
        subSubLabel: '3rd level category',
        sorting: (row) => (
            getSortingValue(row.tournament_or_content_category_level_3)
        ),
    },
    'venue_or_court': {
        label: 'Venue / Court / TV Channel',
        sorting: (row) => (`${(row.venue_or_court || '')}${(row.tv_channel || '')}`),
    },
    'competitors': {
        label: 'Competitors / Name / Description',
        sorting: (row) => {
            const noCompetitorsText = 'No competitors defined';

            if (row.competitors && row.competitors !== noCompetitorsText) {
                return row.competitors;
            }

            if (row.stage_name_or_description) {
                return row.stage_name_or_description;
            }

            return '';
        },
    },
    'status': {
        label: 'Status',
        sorting: true,
    },
    'coverage': {
        label: 'Coverage',
        content: {singleLine: true},
    },
    'contents': {label: 'Content', content: {singleLine: true}},
    'contribution_types': {label: 'Contribution type', content: {singleLine: true}},
    'encoding_datacenters': {label: 'Datacenter', content: {singleLine: true}},
    'products': {label: 'Product', content: {singleLine: true}},
    'distribution_types': {label: 'Distribution type', content: {singleLine: true}},
    'product_statuses': {label: 'Product status', content: {singleLine: true}},
    'targets': {
        label: 'Targets',
        header: {
            align: 'center',
        },
        content: {
            align: 'center',
            singleLine: true,
        },
    },
    'bookings': {
        label: 'Bookings',
        header: {
            align: 'center',
        },
        content: {
            align: 'center',
            singleLine: true,
        },
    },
    'report_scope': {
        label: 'Report',
        header: {
            align: 'center',
        },
        content: {
            align: 'center',
        },
    },
    'notes': {label: 'Notes'},
    'actions': {
        label: 'Actions',
        header: {
            align: 'center',
        },
        content: {
            align: 'center',
        },
    },
};
